<template>
  <div class="site-connect-benefit-item">
    <div class="site-connect-benefit-item__icon" v-html="icon" aria-hidden="true" />
    <div class="site-connect-benefit-item__content">
      <strong class="site-connect-benefit-item__title"> {{ title }} </strong>
      <p class="site-connect-benefit-item__text">{{ text }}</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { BenefitItemProps } from './benefit-item.types'

defineProps<BenefitItemProps>()
</script>
<style lang="scss" scoped>
@import './benefit-item.scss';
</style>
